import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { EftersynStateEnum } from 'src/app/api/models/OK/Egis/Service/Models/DTO/Enums/eftersyn-state-enum';
import { ServiceaftaleDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/serviceaftale-dto';
import { ServiceintervalDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/serviceinterval-dto';

@Component({
    selector: 'app-slutopgoerelse-quickview',
    templateUrl: './slutopgoerelse-quickview.component.html',
    styleUrls: ['./slutopgoerelse-quickview.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SlutopgoerelseQuickviewComponent implements OnInit {
  @Input() serviceaftale: ServiceaftaleDto;

  private _endDate: Date;
  @Input() set endDate(value: Date) {
    this._endDate = value;
    this.getSidsteServiceinterval();
  }
  get endDate(): Date {
    return this._endDate;
  }

  sidsteServiceinterval: ServiceintervalDto;

  eftersynStateEnum = EftersynStateEnum;

  constructor() {}

  ngOnInit(): void {}

  getSidsteServiceinterval() {
    const sidsteServiceintervaller = this.serviceaftale.serviceintervaller.filter(
      (x) => new Date(x.startDate) <= new Date(this._endDate) && new Date(x.endDate) >= new Date(this._endDate)
    );
    this.sidsteServiceinterval = sidsteServiceintervaller.length < 1 ? null : sidsteServiceintervaller[0];
  }
}
